import { Variants } from 'framer-motion';

export const createStepVariants = (reducedMotion: boolean): Variants => ({
  hidden: {
    opacity: 0,
    y: reducedMotion ? 0 : 12
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: reducedMotion ? 0 : 0.24,
      staggerChildren: reducedMotion ? 0 : 0.06
    }
  },
  exit: {
    opacity: 0,
    y: reducedMotion ? 0 : -8,
    transition: {
      duration: reducedMotion ? 0 : 0.14
    }
  }
});

export const createStepChunkVariants = (reducedMotion: boolean): Variants => ({
  hidden: { opacity: 0, y: reducedMotion ? 0 : 8 },
  visible: { opacity: 1, y: 0 }
});
